import "./style.css";

function MobileAbout({ aboutImage, aboutUsTitle, aboutUsText }: any) {
  return (
    <div className="mobile-about">
      <div className="mobile-about-wrapper container">
        <div className="text-content">
          <h1>RÓLUNK</h1>
          <h2>{aboutUsTitle}</h2>
          <br />
          <br />
          {aboutUsText?.map((data: any, index: number) => (
            <p key={index}>{data.aboutUsParagraph}</p>
          ))}
        </div>
      </div>
      <div className="mobile-about-image">
        <img alt="" className="about-me-img" src={aboutImage}></img>
      </div>
    </div>
  );
}

export default MobileAbout;
